import { getSubscriptionDataTypes } from "./subscriptionAccess";

const ADMIN_SESSION_KEY = "impersonationAdminSession";

export const isImpersonating = () => Boolean(localStorage.getItem(ADMIN_SESSION_KEY));

const sessionKeys = [
  "user",
  "usertoken",
  "is_subscribed",
  "new_user",
  "subscription_end_at",
  "subscription_data_types",
  "subscription_plan",
];

export const captureCurrentSession = () => {
  return sessionKeys.reduce((session, key) => {
    session[key] = localStorage.getItem(key);
    return session;
  }, {});
};

export const applyAuthPayload = (data) => {
  localStorage.setItem("user", JSON.stringify(data));
  localStorage.setItem("usertoken", JSON.stringify(data.idToken));
  localStorage.setItem("is_subscribed", JSON.stringify(data.is_subscribed));
  localStorage.setItem("new_user", JSON.stringify(data.new_user));
  localStorage.setItem("subscription_end_at", JSON.stringify(data.subscription_end_at));
  localStorage.setItem("subscription_data_types", JSON.stringify(getSubscriptionDataTypes(data?.data_types || data)));
  localStorage.setItem("subscription_plan", JSON.stringify(data?.data_types?.plan));
};

export const startImpersonationSession = (data) => {
  if (!isImpersonating()) {
    localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(captureCurrentSession()));
  }

  applyAuthPayload(data);
};

export const restoreAdminSession = () => {
  const rawSession = localStorage.getItem(ADMIN_SESSION_KEY);

  if (!rawSession) {
    return false;
  }

  const adminSession = JSON.parse(rawSession);

  sessionKeys.forEach((key) => {
    if (adminSession[key] === null || adminSession[key] === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, adminSession[key]);
    }
  });

  localStorage.removeItem(ADMIN_SESSION_KEY);
  return true;
};

export const clearImpersonationSession = () => {
  localStorage.removeItem(ADMIN_SESSION_KEY);
};
